const DissolveBadge = ({ type = "badge", style = {} }) => {
  return (
    <div
      style={
        type === "badge"
          ? {
              backgroundColor: "#cddaf8",
              border: "1px solid #4b7eff",
              padding: "3px 6px",
              whiteSpace: "nowrap",
              borderRadius: "99px",
              fontSize: "10px",
              color: "#4b7eff",
            }
          : {
              ...style,
            }
      }
    >
      {type === "badge" ? "解散" : "(解散)"}
    </div>
  );
};

export default DissolveBadge;
